import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import Preloader from "../helper/Preloader";
import HeaderOne from "../components/HeaderOne";
import Breadcrumb from "../components/Breadcrumb";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShippingOne from "../components/ShippingOne";
import ScrollToTop from "react-scroll-to-top";
import ColorInit from "../helper/ColorInit";
import { useAuth } from "../contexts/AuthContext";

const LoginPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    setError(""); // Her değişiklikte hata mesajını temizle
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const result = await login(formData.email, formData.password);
      if (result.success) {
        const from = location.state?.from?.pathname || "/";
        navigate(from);
      } else {
        setError(result.error);
      }
    } catch (err) {
      setError("Giriş yapılırken bir hata oluştu");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <ColorInit color={false} />
      <ScrollToTop smooth color="#299E60" />
      <Preloader />
      <HeaderOne />
      <Breadcrumb title={"Giriş Yap"} />

      <div className="login-area pt-100 pb-100">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-6">
              <div className="login-form-wrapper">
                <h3>Giriş Yap</h3>
                <form onSubmit={handleSubmit} className="login-form">
                  {error && (
                    <div className="alert alert-danger" role="alert">
                      {error}
                    </div>
                  )}

                  <div className="single-input-item">
                    <label>E-posta Adresi *</label>
                    <input
                      type="email"
                      name="email"
                      placeholder="E-posta adresinizi giriniz"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="single-input-item">
                    <label>Şifre *</label>
                    <input
                      type="password"
                      name="password"
                      placeholder="Şifrenizi giriniz"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                  </div>

                  <div className="single-input-item d-flex align-items-center justify-content-between">
                    <div className="forgot-password">
                      <Link to="#">Şifremi Unuttum?</Link>
                    </div>
                  </div>

                  <div className="single-input-item">
                    <button 
                      type="submit" 
                      className="btn-hover login-btn rounded-16"
                      disabled={loading}
                    >
                      {loading ? "Giriş Yapılıyor..." : "Giriş Yap"}
                    </button>
                  </div>

                  <div className="divider">
                    <span>veya</span>
                  </div>

                  <div className="single-input-item">
                    <Link to="/register" className="btn-hover register-btn rounded-16">
                      Yeni Hesap Oluştur
                    </Link>
                  </div>

                  {location.state?.from?.pathname === '/checkout' && (
                    <>
                      <div className="divider">
                        <span>veya</span>
                      </div>
                      <div className="single-input-item">
                        <button 
                          type="button" 
                          className="btn-hover register-btn rounded-16"
                          onClick={() => navigate('/checkout', { state: { proceedAsGuest: true }, replace: true })}
                          style={{ width: '100%', backgroundColor: '#f0f0f0', color: '#333', border: '1px solid #ccc' }}
                        >
                          Hesap Oluşturmadan Devam Et
                        </button>
                      </div>
                    </>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ShippingOne />
      <FooterOne />
      <BottomFooter />
    </>
  );
};

export default LoginPage;
